import { RepayDialogContentContainer } from './RepayDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'
import { SparkLendToken } from '@/features/sparklend/tokens/SparkLendToken'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export interface RepayDialogProps extends CommonDialogProps {
  reserve: Reserve
  initialRepayToken: SparkLendToken
}

function RepayDialog({ reserve, initialRepayToken, open, setOpen }: RepayDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <RepayDialogContentContainer
          reserve={reserve}
          initialRepayToken={initialRepayToken}
          closeDialog={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  )
}

export const repayDialogConfig: DialogConfig<RepayDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: RepayDialog,
  name: 'RepayDialog',
}
